<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
<div class="content flex gap-5 w-100"><!---flex-->
    <mat-card class="border-20 w-50" style="min-height:250px">
        <mat-card-content>
            <div *ngIf="userProfile"><!---class="wave-background"-->
                <div *ngIf="isUploading; else image" class="spinner-wrapper">
                    <mat-spinner [diameter]="40"></mat-spinner>
                </div>
                <ng-template #image>
                    <div class="w-full">
                        <div class="flex flex-col items-center" style="width: 100%;margin-top:20px;">
                            <ngx-avatar size="100" [src]="userProfile?.userImage ? userProfile?.userImage : ''"
                                [name]="userProfile?.firstName + ' ' + userProfile?.lastName" [textSizeRatio]="2"
                                [round]="false" [initialsSize]="2" [cornerRadius]="20"></ngx-avatar>
                            <button mat-icon-button class="edit-avatar" (click)="onClickUploader()">
                                {{ userProfile?.userImage ? 'Edit' : 'Upload' }}
                                <mat-icon class="material-icons-round">photo_camera</mat-icon>
                            </button>
                            <input class="d-none" #avatarInput type="file" accept="image/*"
                                (change)="onFileChange($event)" />
                        </div>
                        <div *ngIf="(userProfile?.plantCode !== 'GROUPADMIN')" class="flex flex-row mb-2"
                            style="width: 100%; justify-content:center; align-items: center;">
                            <button mat-raised-button color="primary" (click)="openModal()" style="margin-right: 10px;">
                                <span style="color: #fff;">
                                    User Formatting
                                </span>
                                <mat-icon style="color: #fff;">edit</mat-icon>
                            </button>
                            <button mat-stroked-button color="primary" (click)="resetUserConfiguration()">
                                <span style="color: #005cbb;">
                                    Reset to default
                                </span>
                                <mat-icon style="color: #005cbb;">refresh</mat-icon>
                            </button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </mat-card-content>
    </mat-card>
    <mat-card class="border-20 w-50" style="min-height:250px; display: flex; flex-direction: column;">
        <mat-card-content>
            <div *ngIf="userProfile" style="margin-top:20px;">
                <div *ngIf="userProfile">
                    <div class="flex w-full flex-col">
                        <div class="flex w-full gap-2">
                            <div class="flex flex-col" style="flex: 1; padding: 16px;">
                                <div [@scaleIn]="userProfile?.firstName"></div>
                                <div [@fadeInRight]="userProfile?.firstName" class="flex gap-1">
                                    <p class="m-0 caption text-bold font-14">First Name: </p>
                                    <p class="m-0 caption text-hint text-bold" style="margin-left: auto;">{{
                                        userProfile?.firstName }}</p>
                                </div>
                            </div>
                            <div class="flex flex-col" style="flex: 1; padding: 16px;">
                                <div [@scaleIn]="userProfile?.lastName"></div>
                                <div [@fadeInRight]="userProfile?.lastName" class="flex gap-1">
                                    <p class="m-0 caption text-bold font-14">Last Name: </p>
                                    <p class="m-0 caption text-hint text-bold" style="margin-left: auto;">{{
                                        userProfile?.lastName }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="flex w-full gap-2">
                            <div class="flex flex-col" style="flex: 1; padding: 16px;">
                                <div [@scaleIn]="userProfile?.userCode"></div>
                                <div [@fadeInRight]="userProfile?.userCode" class="flex gap-1">
                                    <p class="m-0 caption text-bold font-14">Code: </p>
                                    <p class="m-0 caption text-hint text-bold" style="margin-left: auto;">{{
                                        userProfile?.userCode }}</p>
                                </div>
                            </div>
                            <div class="flex flex-col" style="flex: 1; padding: 16px;">
                                <div [@scaleIn]="userProfile?.userName"></div>
                                <div [@fadeInRight]="userProfile?.userName" class="flex gap-1">
                                    <p class="m-0 caption text-bold font-14">Username: </p>
                                    <p class="m-0 caption text-hint text-bold" style="margin-left: auto;">{{
                                        userProfile?.userName }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="flex w-full gap-2">
                            <div class="flex flex-col" style="flex: 1; padding: 16px;">
                                <div [@scaleIn]="userProfile?.email"></div>
                                <div [@fadeInRight]="userProfile?.email" class="flex gap-1">
                                    <p class="m-0 caption text-bold font-14">Email: </p>
                                    <p class="m-0 caption text-hint text-bold" style="margin-left: auto;">{{
                                        userProfile?.email }}</p>
                                </div>
                            </div>
                            <div class="flex flex-col" style="flex: 1; padding: 16px;">
                                <div [@scaleIn]="userProfile?.phoneNumber"></div>
                                <div [@fadeInRight]="userProfile?.phoneNumber" class="flex gap-1">
                                    <p class="m-0 caption text-bold font-14">Phone: </p>
                                    <p class="m-0 caption text-hint text-bold" style="margin-left: auto;">{{
                                        userProfile?.phoneNumber }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="flex w-full gap-2">
                            <div class="flex flex-col" style="flex: 1; padding: 16px;">
                                <div [@scaleIn]="userProfile?.status"></div>
                                <div [@fadeInRight]="userProfile?.status" class="flex gap-1">
                                    <p class="m-0 caption text-bold font-14">Status: </p>
                                    <p class="m-0 caption text-hint text-bold" style="margin-left: auto;">{{
                                        userProfile?.status }}</p>
                                </div>
                            </div>
                            <div class="flex flex-col" style="flex: 1; padding: 16px;">
                                <div [@scaleIn]="userProfile?.isDefault"></div>
                                <div [@fadeInRight]="userProfile?.isDefault" class="flex gap-1">
                                    <p class="m-0 caption text-bold font-14">Is Default: </p>
                                    <p class="m-0 caption text-hint text-bold" style="margin-left: auto;">{{
                                        userProfile?.isDefault ? 'Yes' : 'No' }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>
<div style="margin-top: 20px;">
    <mat-accordion style="margin-top: 20px">
        <mat-expansion-panel>
            <mat-expansion-panel-header class="acc1 disable_ripple_acc1"
                style="display: flex; justify-content: center; align-items: center;">
                <mat-panel-title style="font-weight: bold;">
                    Roles & Department
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div *ngIf="userProfile" style="margin-top: 20px">
                <div class="flex flex-row w-full">
                    <div class="flex flex-col gap-3" style="width: 100%;">

                        <!-- Role(s) -->
                        <div class="flex flex-col">
                            <div class="flex justify-center gap-1">
                                <p class="m-0 caption text-bold font-14">Role(s)</p>
                            </div>
                            <div class="flex flex-wrap gap-1"
                                style="margin-top: 10px;margin-bottom: 10px;font-weight: bold;">
                                <div class="custom-mat-chip" *ngFor="let role of userProfile?.roles | stringToArray"
                                    [@fadeInRight]="role">
                                    {{ role }}
                                </div>
                            </div>
                        </div>

                        <!-- Department(s) -->
                        <div class="flex flex-col">
                            <div class="flex justify-center gap-1">
                                <p class="m-0 caption text-bold font-14">Department(s)</p>
                            </div>
                            <div class="flex flex-wrap gap-1"
                                style="margin-top: 10px;margin-bottom: 10px;font-weight: bold;">
                                <div class="custom-mat-chip"
                                    *ngFor="let department of userProfile?.departments | stringToArray"
                                    [@fadeInRight]="department">
                                    {{ department }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
            style="margin-top: 15px">
            <mat-expansion-panel-header class="acc2" class="disable_ripple_acc2">
                <mat-panel-title>
                    Users/Report/Date/Current
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngIf="userProfile" style="margin-top: 20px">
                <div class="flex flex-wrap w-full">
                    <div class="flex gap-1 items-center" style="width: 25%;">
                        <div [@scaleIn]="defaultPlant?.dateFormat">
                        </div>
                        <div [@fadeInRight]="defaultPlant?.dateFormat" class="flex gap-1">
                            <p class="m-0 caption text-bold font-14">Default Date Format : </p>
                            <p class="m-0 caption text-hint text-bold">{{ defaultPlant?.dateFormat }}</p>
                        </div>
                    </div>
                    <div class="flex gap-1 items-center" style="width: 25%;">
                        <div [@scaleIn]="userconfiguration?.dateFormat">
                        </div>
                        <div [@fadeInRight]="userconfiguration?.dateFormat" class="flex gap-1">
                            <p class="m-0 caption text-bold font-14">New Date Format : </p>
                            <p class="m-0 caption text-hint text-bold">{{ userconfiguration?.dateFormat }}</p>
                        </div>
                    </div>
                    <div class="flex gap-1 items-center" style="width: 25%;">
                        <div [@scaleIn]="defaultPlant?.timeFormat">
                        </div>
                        <div [@fadeInRight]="defaultPlant?.timeFormat" class="flex gap-1">
                            <p class="m-0 caption text-bold font-14">Default Time Format: </p>
                            <p style="text-transform: none;" class="m-0 caption text-hint text-bold normal-case">
                                {{ defaultPlant?.timeFormat
                                ? (defaultPlant.timeFormat === 'HH:mm:ss'
                                ? 'HH:mm:ss (24-Hour Format)'
                                : 'hh:mm:ss (12-Hour Format)')
                                : ''
                                }}
                            </p>
                        </div>

                    </div>
                    <div class="flex gap-1 items-center" style="width: 25%;">
                        <div [@scaleIn]="userconfiguration?.timeFormat">
                        </div>
                        <div [@fadeInRight]="userconfiguration?.timeFormat" class="flex gap-1">
                            <p class="m-0 caption text-bold font-14">New Time Format : </p>
                            <p style="text-transform: none;" class="m-0 caption text-hint text-bold">
                                {{ userconfiguration?.timeFormat ? (userconfiguration.timeFormat === "HH:mm:ss" ?
                                "HH:mm:ss (24-Hour Format)" : "hh:mm:ss (12-Hour Format)") : "" }}
                            </p>
                        </div>
                    </div>
                    <div class="flex gap-1 items-center" style="width: 25%;">
                        <div [@scaleIn]="defaultPlant?.dateFormat">
                        </div>
                        <div [@fadeInRight]="defaultPlant?.dateFormat" class="flex gap-1">
                            <p class="m-0 caption text-bold font-14">Default Currency : </p>
                            <p class="m-0 caption text-hint text-bold">{{ defaultPlant?.currencyName
                                +' ('+defaultPlant?.currencySymbol+')' }}</p>
                        </div>
                    </div>
                    <div class="flex gap-1 items-center" style="width: 25%;">
                        <div [@scaleIn]="userconfiguration?.currencyCode">
                        </div>
                        <div [@fadeInRight]="userconfiguration?.currencyCode" class="flex gap-1">
                            <p class="m-0 caption text-bold font-14">New Currency : </p>
                            <p class="m-0 caption text-hint text-bold">{{ userconfiguration ?
                                userconfiguration?.currencyName+' ('+userconfiguration?.currencySymbol+')' : '' }}
                            </p>
                        </div>
                    </div>
                    <div class="flex gap-1 items-center" style="width: 25%;">
                        <div [@scaleIn]="defaultPlant?.dateFormat">
                        </div>
                        <div [@fadeInRight]="defaultPlant?.dateFormat" class="flex gap-1">
                            <p class="m-0 caption text-bold font-14">Default Report Number Format : </p>
                            <p class="m-0 caption text-hint text-bold">{{ defaultPlant?.reportNumberFormat }}</p>
                        </div>
                    </div>
                    <div class="flex gap-1 items-center" style="width: 25%;">
                        <div [@scaleIn]="userconfiguration?.reportNumberFormat">
                        </div>
                        <div [@fadeInRight]="userconfiguration?.reportNumberFormat" class="flex gap-1">
                            <p class="m-0 caption text-bold font-14">New Report Numbering Format : </p>
                            <p class="m-0 caption text-hint text-bold">{{userconfiguration?.reportNumberFormat}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>
<div>
    <mat-card class="border-20 w-100" style="margin-top: 20px;">
        <mat-card-content>
            <div class="title">
                <h2>User Plants</h2>
            </div>
            <div *ngIf="userProfile?.userPlants?.length === 0">
                <p class="text-hint text-center">No Plants Found</p>
            </div>
            <div *ngIf="userProfile?.userPlants?.length > 0">
                <div class="plants-container">
                    <div *ngFor="let plant of userProfile?.userPlants" [class]="(plant?.plantCode === plantCode && plant?.isDeleted === false) 
               ? 'flex items-center mt-5 bg-white rounded-lg shadow-lg border-right' 
               : 'flex items-center mt-5 bg-white rounded shadow-lg'">

                        <!-- Left part: Avatar -->
                        <div class="flex-shrink-0 p-4">
                            <ngx-avatar size="80"
                                [src]="(plant?.plantCode === '0' || plant.plantCode === 'GROUPADMIN') ? '' : plant?.plantImage"
                                [name]="(plant?.plantCode === '0' || plant.plantCode === 'GROUPADMIN') ? 'Default Plant' : plant?.plantName"
                                [textSizeRatio]="2" [round]="false" [cornerRadius]="20" [initialsSize]="2"
                                class="hexagon-avatar">
                            </ngx-avatar>
                        </div>

                        <!-- Right part: Details -->
                        <div class="flex flex-col justify-between p-4 leading-normal flex-grow">
                            <h5 class="mb-2 text-lg font-bold tracking-tight">
                                {{(plant?.plantCode === '0' || plant.plantCode === 'GROUPADMIN')
                                ? ('Default Plant ( ' + plant?.plantCode + ' )')
                                : (plant?.plantName + ' ( ' + plant?.plantCode + ' )')}}
                            </h5>

                            <p class="mb-3 ml-3 font-normal"
                                [ngClass]="{'scrollable-text': plant?.description?.length > 100}">
                                {{(plant?.plantCode === '0' || plant?.plantCode === 'GROUPADMIN')
                                ? 'This is the default plant, and there is no need of description'
                                : plant?.description}}
                            </p>

                            <div class="flex items-center gap-2">
                                <div *ngIf="plant?.isDefault">
                                    <button mat-raised-button
                                        style="height: 30px; padding: 0; display: flex; align-items: center; justify-content: center;">
                                        <span style="color: #005cbb; line-height: 1;">{{'Default'}}</span>
                                    </button>
                                </div>

                                <app-boolean-view width="105px" [value]="plant?.status === 'ACTIVE'"
                                    [text]="plant?.status === 'ACTIVE' ? 'Active' : 'Inactive'">
                                </app-boolean-view>

                                <div *ngIf="plant?.isDeleted"
                                    class="rounded px-2 py-1 font-medium text-md flex-none text-red bg-red-light">
                                    {{'Deleted'}}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>
<ng-template #userFormatModel>
    <mat-dialog-title>
        <div style="display:flex;justify-content:space-between;">
            <h1>User Formatting</h1>

            <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close" class="close-btn">
                <i class="fa fa-times" style="color: #fff"></i>
            </button>

        </div>


    </mat-dialog-title>
    <mat-dialog-content>
        <form [formGroup]="userprofileForm">
            <div class=" flex flex-col  h-100   gap-10">
                <section class="plant-info-section">
                    <div class="flex flex-col h-100 gap-5">
                        <div class="content-top-row justify-space-between gap-5">
                            <mat-form-field
                                class="top-row-first-filed-item top-row-first-filed-item-order-processing ml-0 w-100">
                                <mat-label>Date Format </mat-label>
                                <mat-select formControlName="dateformat" panelClass="testClass" name="Dateformat"
                                    [required]="true">
                                    <mat-select-filter [placeholder]="'Search'" [displayMember]="'value'"
                                        [array]="dateFormatList"
                                        (filteredReturn)="filteredDateFormatList = $event"></mat-select-filter>
                                    <mat-option *ngFor="let date of filteredDateFormatList" [value]="date">
                                        {{ date.format }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field
                                class="top-row-first-filed-item top-row-first-filed-item-order-processing ml-0 w-100">
                                <mat-label>Time Format </mat-label>
                                <mat-select formControlName="timeformat" panelClass="testClass" name="Hourformat"
                                    [required]="true">
                                    <mat-option *ngFor="let time of timeformatlist" [value]="time.format">
                                        {{ time.formatName }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field
                                class="top-row-first-filed-item top-row-first-filed-item-order-processing ml-0 w-100">
                                <mat-label>Currency</mat-label>
                                <mat-select formControlName="currencyunit" panelClass="testClass" name="CurrencyUnit"
                                    (selectionChange)="onChangeCurrency($event)" [required]="true">
                                    <mat-select-filter [placeholder]="'Search'" [displayMember]="'currencyCode'"
                                        [array]="getCurrencyList"
                                        (filteredReturn)="fileredCurrencyList = $event"></mat-select-filter>
                                    <mat-option *ngFor="let currency of fileredCurrencyList" [value]="currency.id"
                                        matTooltip="{{ currency.currencyName}}  ({{
                                                                            currency.currencySymbol}})">

                                        {{ currency.currencyName}} ({{currency.currencySymbol}})
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field
                                class="top-row-first-filed-item top-row-first-filed-item-order-processing ml-0 w-100">
                                <mat-label>Report Number Format</mat-label>
                                <mat-select formControlName="reportNumberFormat" panelClass="testClass"
                                    name="reportNumberFormat" [required]="true"
                                    matTooltip="Selected Format: {{ selectedCurrencyFormat }}">

                                    <mat-select-filter [placeholder]="'Search'" [displayMember]="'name'"
                                        [array]="reportFormat" (filteredReturn)="reportFormatList = $event">
                                    </mat-select-filter>

                                    <mat-option *ngFor="let currency of reportFormatList" [value]="currency.value"
                                        matTooltip="({{ currency.value }}) {{ currency.name }}">
                                        ({{ currency.value }}) {{ currency.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>


                        </div>
                    </div>
                </section>
            </div>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions class="flex justify-end">
        <button mat-raised-button mat-dialog-close color="warn">Cancel</button>
        <button mat-raised-button color="primary" [class.disabled]="userprofileForm.invalid"
            (click)="editMode ?  updateUserConfiguration() : createUserConfiguration()"><span style="color: #fff;">{{
                editMode ? 'Update' : 'Create'
                }}</span></button>
    </mat-dialog-actions>
</ng-template>